import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { createAlertEnabled } from 'common/features/create-alert/enabled';
import { abTestsIsVariant } from 'common/helper/ab-tests/is-variant';
import { DataStore } from 'common/module/data/store';
import { MyAccountHeaderTemplatePropsInterface } from 'desktop/module/my-account/header/template-props.interface';
import { MyAccountHeaderViewStoreEvent } from 'desktop/module/my-account/header/view-store.event';
import { MyAccountHeaderViewStoreOptionsInterface } from 'desktop/module/my-account/header/view-store-options.interface';

export class MyAccountHeaderViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: MyAccountHeaderTemplatePropsInterface;

  /**
   * Constructor
   */
  constructor(eventEmitter: EventEmitterInterface) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(options: MyAccountHeaderViewStoreOptionsInterface): void {
    const categoryChoices = options.categories?.choices || [];
    const filterChoices = options.filters?.choices || [];

    this.state = {
      listType: options.listType,
      showDeleteAll:
        (!createAlertEnabled() && !abTestsIsVariant('SEARCH_CREATE_ALERT_FLOW', 'variantA')) ||
        categoryChoices.length > 0,
      categoryOptions: categoryChoices,
      categoryValue: '',
      sortOptions: filterChoices,
      sortValue: options.filters?.value,
      onChangeCategoryDropdown: this.onChangeCategoryDropdown,
      onClickDeleteAll: this.onClickDeleteAll,
      onChangeSortByDropdown: this.onChangeSortByDropdown,
    };
  }

  /**
   * @inheritDoc
   */
  public getState(): MyAccountHeaderTemplatePropsInterface {
    return this.state;
  }

  /**
   * @inheritDoc
   */
  public getEventEmitter(): EventEmitterInterface {
    return this.eventEmitter;
  }

  /**
   * Change category
   */
  private onChangeCategoryDropdown = (value: string) => {
    this.setState({ ...this.state, categoryValue: value });
    this.getEventEmitter().emit(MyAccountHeaderViewStoreEvent.filterSavedProperties, value, this.state.sortValue);
  };

  /**
   * Delete all saved properties
   */
  private onClickDeleteAll = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    this.getEventEmitter().emit(MyAccountHeaderViewStoreEvent.deleteAllSavedProperties);
  };

  /**
   *
   */
  private onChangeSortByDropdown = (option: string) => {
    this.setState({ ...this.state, sortValue: option });
    this.getEventEmitter().emit(MyAccountHeaderViewStoreEvent.sortSavedProperties, option);
  };
}
